import Avatar from "../Tools/Avatar"
import { Stack} from "@mui/material"
import { useState } from "react";
import Comments from "./Comments";
import CommentForm from "./CommentForm";
import Reactions from "./Reactions";
import Actions from "./Actions";
import Tag from "./Tag";
import Options from "./Options";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import { timeAgo } from "../../services/timeAgo";
import Tip from "../Tools/Tip";
import { Link } from "react-router-dom";
import { useContext } from "react";
import { UserContext } from "../../services/Context/UserContext";
import { txt } from "../../services/translation";

export default function Post({post, onTagClick, onDelete, queryKey, page, zoom}){


    const [showComments, setShowComments] = useState(false);
    const [showCommentForm, setShowCommentForm] = useState(false);
    const [showReactionForm, setShowReactionForm] = useState(false);
    const [recipient, setRecipient] = useState(null)

    const handleNewComment = () => {
        setShowCommentForm(false);
        return setShowComments(true);
    }

    const handleReact = () => {
        if(showReactionForm) return setShowReactionForm(false);
        return setShowReactionForm(true);
    }

    const handleReply = recipient => {
        setShowCommentForm(true)
        setShowComments(false)
        return setRecipient(recipient)
    }

    return <article className='social-box' data-id={post.id} >

        <Top post={post} onDelete={onDelete} zoom={zoom}/>

        <div className='social-post-content'>

            <Content 
                post={post}
                onTagClick={tag => onTagClick(tag)}
            />
            
            <Stack direction='row' justifyContent='space-between' sx={{mt: 1}}>

                <Reactions 
                    post={post} 
                    form={showReactionForm}
                    onClose={() => setShowReactionForm(false)}
                    queryKey={queryKey}
                    page={page}
                />

                <CommentsLink
                    post={post} 
                    onClick={() => setShowComments(!showComments)}
                    show={showComments}
                />

            </Stack>

        </div>
        
        <Actions 
            post={post}
            onComment={() => setShowCommentForm(!showCommentForm)}
            onReact={handleReact}
            showReactionForm={showReactionForm}
            onReactionsFormClose={() => setShowReactionForm(false)}
            queryKey={queryKey}
            page={page}
        />

        {showCommentForm && 
            <CommentForm 
                post={post} 
                onClose={() => setShowCommentForm(false)}
                onSuccess={handleNewComment}
                onError={() => false}
                queryKey={queryKey}
                page={page}
                show={showCommentForm}
                recipient={recipient}
            />
        }


        {showComments &&
            <Comments 
                post={post} 
                onClose={() => setShowComments(false)}
                queryKey={queryKey}
                page={page}
                onReply={recipient => handleReply(recipient)}
            />
        }

    </article>
}



function Top({post, onDelete, zoom}){

    const {user} = useContext(UserContext)

    return <Stack direction='row' justifyContent='space-between'>

        <Stack direction='row'>

            <Avatar 
                initials={post.anonymous ? 'A' : post.author?.initials} 
                color={post.author?.category?.color} 
            />

            <span style={{marginLeft: 10}}>
                <b>{post.anonymous ? txt('anonymousPost') : post.author.name}</b>
                <br/>
                <small>{timeAgo(post.createdAt)}</small>
            </span>

        </Stack>
        
        <Stack direction='row'>

            {(post.mine || user.admin) && 
                <Options post={post} onDelete={onDelete} />
            }

            {zoom &&
                <Link to='/community/feed'>
                    <Tip type='close' title={false}/>
                </Link>
            }

        </Stack>

    </Stack>

}


function Content({post, onTagClick}){

    return <div>

        {post.course &&
            <small>{post.course.title}</small>
        }

        <p><strong>{post.title}</strong></p>

        {post.class !== 'post' && 
            <p>{post.content}</p>
        }

        {post.class === 'post' && 
            <div dangerouslySetInnerHTML={
                {__html: post.content.replaceAll('<p><br></p>', '')}
            }></div>
        }


        {post.pictures.length > 0 && 
            <div className='social-carousel'>
                <Carousel>
                    {post.pictures.map(p => 
                        <div key={p}>
                            <img src={p} alt={p}/> 
                        </div>
                    )}
                </Carousel>
            </div>
        }

        {post.tags?.length > 0 && 
            <Stack direction='row' sx={{flexWrap: 'wrap', mt: 3}}>

                {post.tags
                    .filter(t => t.type?.id === 'category')
                    .map(t => 
                        <Tag key={t.id} tag={t} onClick={() => onTagClick(t)}/>   
                    )}

            </Stack>
        }

    </div>
}



function CommentsLink({post, onClick, show}){

    const cc = post.commentsCount;

    const comments = cc + ' ' + (cc > 1 ? txt('comments') : txt('comment'));

    return <div>

        {cc > 0 && 
            <span 
                className='social-post-comments-link'
                onClick={onClick}
            >
                {show ? txt('hideComments') : comments}
            </span>
        }

    </div>
}
